import { getEventDetails } from '@store/slices/eventSlice';
import { SessionsRoot, Underline, TitleText } from './styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SessionInfoItem from './SessionInfoItem';
import { useEffect, useState } from 'react';

// Interface based on actual session data structure
export interface SessionItem {
  session_id: string;
  start_date: string;
  end_date: string;
  title: string;
  sub_title?: string;
  description: string;
  type: string;
  location: string;
  location_name: string;
  location_description?: string;
  // Keeping city for backward compatibility
  city?: string;
}

const Sessions = ({ sessions }: { sessions?: SessionItem[] }) => {
  const { t } = useTranslation();
  const sluggedEvent = useSelector(getEventDetails)?.[0];
  const [sortedSessions, setSortedSessions] = useState<SessionItem[]>([]);

  useEffect(() => {
    if (sessions) {
      const sorted = [...sessions].sort((a, b) => {
        const startA = new Date(a.start_date).getTime();
        const startB = new Date(b.start_date).getTime();
        if (startA !== startB) {
          return startA - startB;
        }
        // If start_date is equal, compare end_date
        const endA = new Date(a.end_date).getTime();
        const endB = new Date(b.end_date).getTime();
        return endA - endB;
      });
      setSortedSessions(sorted);
    }
  }, [sessions]);

  if (!sessions?.length) return null;

  return (
    <SessionsRoot>
      <TitleText color={sluggedEvent?.design?.headerFontColor}>
        {t('sessions')}
      </TitleText>
      <Underline color={sluggedEvent?.design?.themeColor} />

      {sortedSessions?.map((sessionItem: SessionItem) => {
        return (
          <SessionInfoItem
            key={
              sessionItem.session_id ||
              `${sessionItem.start_date}-${sessionItem.location}`
            }
            item={sessionItem}
          />
        );
      })}
    </SessionsRoot>
  );
};

Sessions.displayName = 'Sessions';

export default Sessions;
